import { GET_SEARCHED_DATA } from '../Constant';
import { get } from '../networkClient';

const GlobalData = data => ({
  type: GET_SEARCHED_DATA,
  data: data
});

let latestRequestId = 0;

export const GetGlobalSearchData = data => async dispatch => {
  const myRequestId = ++latestRequestId;
  const resp = await get('/search', { q: data }, undefined, true, true);
  if (myRequestId !== latestRequestId) return;
  dispatch(GlobalData(resp.data));
};

export const ClearGlobalSearch = data => async dispatch => {
  latestRequestId += 1;
  dispatch(GlobalData(data));
};
